/*
 * @Author: liang.zhaoqi
 * @Date: 2020-10-16 17:54:59
 * @LastEditTime: 2020-12-25 14:35:17
 * @LastEditors: lzq
 * @FilePath: \muzi-official-website\src\router.js
 * @Email: 2394690057@qq.com
 * @Description: 
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
	//mode: 'hash',/* hash history   npm run build*/ 
	routes: [
		{
			path: '',
			component: () => import('@/pages/index/index.vue')
		}, {
			path: '/index',
			component: () => import('@/pages/index/index.vue')
		},
		{
			name: "richText",
			path: '/richText',
			component: () => import('@/pages/richText/index.vue')
		},
		{
			name: "richText-id",
			path: '/richText/:id',
			component: () => import('@/pages/richText/details.vue')
		},
		{
			name: "students_up",
			path: '/students_up',
			component: () => import('@/pages/students_up/index.vue')
		},
		{
			name: "px_up",
			path: '/px_up',
			component: () => import('@/pages/px_up/index.vue')
		},
		{
			name: "hs_up",
			path: '/hs_up',
			component: () => import('@/pages/hs_up/index.vue')
		},
		{
			name: "letter_box",
			path: '/letter_box',
			component: () => import('@/pages/letter_box/index.vue')
		}
	]
})
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default router